import { render, staticRenderFns } from "./PxfDescription.vue?vue&type=template&id=416942ce&scoped=true"
import script from "./PxfDescription.vue?vue&type=script&lang=js"
export * from "./PxfDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416942ce",
  null
  
)

export default component.exports